module.exports = __webpack_public_path__ + "img/dz.6d5f29ec.svg";